import styled from 'styled-components';

import { useDownloadAttachments } from 'hooks/useDownloadAttachments';
import colors from 'styles/theme/colors';
import DownloadFilesIcon from 'svg/DownloadFilesIcon';

type DownloadFilesLinkProps = {
  reviewId: string;
  attachmentIds?: string[];
  children: (isDownloading: boolean) => React.ReactNode;
};

const DownloadFilesLink = ({ reviewId, attachmentIds, children }: DownloadFilesLinkProps) => {
  const { downloadAttachments, isDownloading } = useDownloadAttachments(reviewId);

  const handleDownloadAllFiles = () => {
    downloadAttachments(attachmentIds);
  };

  return (
    <LinkContainer>
      <LinkWithIcon onClick={handleDownloadAllFiles}>
        <DownloadFilesIcon />
        {children(isDownloading)}
      </LinkWithIcon>
    </LinkContainer>
  );
};

export default DownloadFilesLink;

const LinkContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const LinkWithIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  p {
    font-size: 12px;
    color: ${colors.blue100};

    &:hover {
      text-decoration: underline;
    }
  }
`;
